module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid7.32e925e9.png";